/**
 * Strip AI meta-preamble blocks from a draft audit report.
 *
 * Handles both:
 *   - Prefix recaps ("Here is a brief summary…" before the greeting)
 *   - Trailing recaps ("Regards… Here is a brief summary… || Portfolio Ageing | … ||")
 *
 * Preserves legitimate "In summary of …" body content.
 */
export function stripAiPreamble(raw) {
  let text = String(raw || '');

  // ── 1. Strip prefix preamble before the first greeting line ──────────
  const anchorRe = /^[ \t]*(dear\b|hello\b|hi\b|good\s+(morning|afternoon|evening)\b|greetings\b|reorder\s+request\s+audit|portfolio\s+ageing\s+notice)/im;
  const anchorMatch = text.match(anchorRe);
  if (anchorMatch && anchorMatch.index > 0) {
    const head = text.slice(0, anchorMatch.index);
    if (/^(all\s+\d+\s+steps|here\s+is|here's|below\s+is|this\s+is|sure[!,]?\s+here|step\s*\|?\s*output|step\s+output)/i.test(head.trim())) {
      text = text.slice(anchorMatch.index);
    }
  }

  // ── 2. Strip an embedded "Step | Output" recap table ─────────────────
  text = text.replace(
    /(?:Here is a (?:brief )?summary[^\n]*\n+)?\s*Step\s*[|\t][ \t]*Output[\s\S]*?(?:Portfolio\s+Ageing\s*[|\t][^\n]*|Inventory\s+Audit\s*[|\t][^\n]*)\n+/i,
    ''
  );

  // ── 3. Strip trailing recap that appears AFTER "Regards" ─────────────
  text = text.replace(
    /\n+\s*(?:Here is|Here's|Below is|This is)\s+(?:a\s+)?(?:brief\s+)?(?:summary|recap|breakdown)[\s\S]*$/i,
    '\n'
  );
  text = text.replace(
    /\n+\s*All\s+\d+\s+steps?\s+(?:complete|done)[\s\S]*$/i,
    '\n'
  );
  text = text.replace(
    /\n+\s*Step\s*[|\t][ \t]*Output[\s\S]*$/i,
    '\n'
  );
  text = text.replace(
    /\n+\s*\|+\s*(Portfolio\s+Ageing|Inventory\s+Audit|Email\s+Extraction|Cross-Reference|Audit\s+Rules|PI\s*\(Reorder\))\s*\|[\s\S]*$/i,
    '\n'
  );

  return text
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/^---+$/gm, '').replace(/^___+$/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
